module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(!_vm.started) ? _c('button', {
    attrs: {
      "id": "mobileStart"
    },
    on: {
      "click": _vm.mobileStart
    }
  }, [_vm._v("Mobile Start")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "toolTip"
    },
    on: {
      "mouseover": function($event) {
        _vm.$modal.show('intro')
      }
    }
  }, [_vm._v("?")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "intentions"
    }
  }, _vm._l((_vm.frequencies), function(frequency) {
    return _c('p', {
      style: ({
        fontSize: 4 + frequency.count +
          'px'
      })
    }, [_vm._v(_vm._s(frequency.title))])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "buttons"
    }
  }, [_vm._l((_vm.frequencies), function(frequency, index) {
    return _c('div', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.activate(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(frequency.freq) + "Hz")])])
  }), _vm._v(" "), (_vm.autoPlayOn === false) ? _c('div', {
    staticClass: "button autoPlay",
    on: {
      "click": function($event) {
        _vm.autoPlayOn = true;
        _vm.autoplay()
      }
    }
  }, [_vm._v("Autoplay")]) : _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.autoPlayOn = false
      }
    }
  }, [_vm._v("Stop Autoplay")])], 2), _vm._v(" "), _c('logo', {
    attrs: {
      "id": "logo"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "intro",
      "onselectstart": "return false;"
    }
  }, [_c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('label', [_vm._v("Vibrational Healing")]), _vm._v(" "), _c('p', [_vm._v("Create a generative, healing drone using the "), _c('a', {
    attrs: {
      "href": "https://www.gaiameditation.com/ancient-solfeggio-frequencies-healing-properties/"
    }
  }, [_vm._v("Solfeggio frequencies")]), _vm._v(" to return physical, mental, and spiritual balance. Drone generated through "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Watts%E2%80%93Strogatz_model"
    }
  }, [_vm._v("Watts-Strogatz")]), _vm._v(" model. Headphones stronly recommended. Spotty support on phones.")]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Using It")]), _vm._v(" "), _c('p', [_vm._v("This is a deep listening exercise. Play one note periodically (click/1-9 keys) or press autoplay. As the note plays follow it for as long as you can. Eventually it will merge into the overall drone; note how the drone changes and the new sound that appear. Repeat for 10-15 minutes.")]), _vm._v(" "), _c('p', [_vm._v("Most effective in full screen with full focus.")]), _vm._v(" "), _c('p', [_vm._v(" Use "), _c('a', {
    attrs: {
      "href": "https://attunedvibrations.com/how-to-use-solfeggio-frequencies/"
    }
  }, [_vm._v("at least three times a week.")]), _vm._v(" The art and labels are generated every page load; refresh until you've found what you're looking for. The intention of the frequency appears when played - add as needed.\n                ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("How Does It Work?")]), _c('span', {
    staticClass: "viewToggle",
    on: {
      "click": function($event) {
        _vm.workVisible = !_vm.workVisible
      }
    }
  }, [(_vm.workVisible) ? _c('span', [_vm._v("hide")]) : _c('span', [_vm._v("show")])])]), _vm._v(" "), (_vm.workVisible) ? _c('div', [_c('p', [_vm._v("The drone is structured by a "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Watts%E2%80%93Strogatz_model"
    }
  }, [_vm._v("Watts-Strogatz")]), _vm._v(" network - a model that explains naturally occuring 'small-world' phenomena seen in human societies, cellular structures, and systems of power.")]), _vm._v(" "), _c('p', [_vm._v("Clicking a frequency activates a random node which - based on its relationship with its neighbors - has a chance of passing its signal to a neighbor. The more nodes activate, the louder the sound and the more powerful the effect.")]), _vm._v(" "), _c('p', [_vm._v("The graph itself is generated randomly on page load. When a node is active lines appear showing the nodes to which it is connected. If the line is colored the connection is positive and the node shares its charge with its neighbor. If the line is black the node does not share its charge.")]), _vm._v(" "), _c('p', [_vm._v(" Fifteen seconds after the chain has stopped expanding the volume of the drone decreases to a random, but low, level. The image and labels are probabilistically generated. May get glitchy after awhile if you've got it in a background window. Don't put it in a background window - you're doing one thing here.")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("What's It Built With?")]), _c('span', {
    staticClass: "viewToggle",
    on: {
      "click": function($event) {
        _vm.githubVisible = !_vm.githubVisible
      }
    }
  }, [(_vm.githubVisible) ? _c('span', [_vm._v("hide")]) : _c('span', [_vm._v("show")])])]), _vm._v(" "), (_vm.githubVisible) ? _c('div', [_c('p', [_c('a', {
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, [_vm._v("Vue.js")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://tonejs.github.io/"
    }
  }, [_vm._v("Tone.js")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "https://p5js.org/"
    }
  }, [_vm._v("p5.js")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "https://aws.amazon.com/polly/"
    }
  }, [_vm._v("Amazon Polly")]), _vm._v(". "), _c('a', {
    attrs: {
      "href": "https://github.com/brokyo/healingcodes"
    }
  }, [_vm._v("Full source here")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a199420"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 30
// module chunks = 1